export const stateName = 'abTests' as const
